export default "__VITE_ASSET__D_iSlAY6__"